export { default } from './NewsletterList'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Newsletter/NewsletterList/index.js